export const getFiltersFromUrl = (href = window.location.href) => {
    let url = new URL(href);

    let filters = {
        topics: [],
        types: [],
        languages: [],
        categories: [],
        tags: []
    };

    let urlSegments = url.pathname.split('/');
    const validFilters = {type: "types", topic: "topics", language: "languages"};
    if (urlSegments.length >= 4 && urlSegments[2] in validFilters) {
        filters[validFilters[urlSegments[2]]].push(urlSegments[3]);
    } else if(urlSegments[1] === "category" && urlSegments.length >= 3){
        filters["categories"].push(urlSegments[2]);
    } else if(urlSegments[1] === "tag" && urlSegments.length >= 3){
        filters["tags"].push(urlSegments[2]);
    }

    let queryParams = new URLSearchParams(url.search);
    // since path is only allowed on single selection we can safely overwrite filters here
    if (queryParams.has("top")) {
        filters['topics'] = queryParams.get("top").split(',');
    }
    if (queryParams.has("typ")) {
        filters['types'] = queryParams.get("typ").split(',');
    }
    if (queryParams.has("lan")) {
        filters['languages'] = queryParams.get("lan").split(',');
    }
    if (queryParams.has("cat")) {
        filters['categories'] = queryParams.get("cat").split(',');
    }
    if (queryParams.has("tag")) {
        filters['tags'] = queryParams.get("tag").split(',');
    }

    return {
        term: queryParams.has("s") ? queryParams.get("s") : null,
        filters,
        sort: queryParams.has("sort") ? queryParams.get("sort") : 'date'
    };
};


const generateUrlForFilters = (term=null, {topics=[], tags=[], categories=[], types=[], languages=[]} = {}, sort='date') => {
    let params = new URLSearchParams();
    let pathname = '';

    let isUniqueSelection = [].concat(topics,tags,categories,types,languages).length === 1 && !term;

    if (term) {
        params.append('s', term);
        pathname = '/search/';
    }
    if (topics.length > 0) {
        if (isUniqueSelection) {
            pathname = `/category/topic/${topics[0]}`;
        } else {
            params.append('top', topics.join(','));
        }
    }
    if (tags.length > 0) {
        if (isUniqueSelection) {
            pathname = `/tag/${tags[0]}`;
        } else {
            params.append('tag', tags.join(','));
        }
    }
    if (categories.length > 0) {
        if (isUniqueSelection) {
            pathname = `/category/${categories[0]}`;
        } else {
            params.append('cat', categories.join(','));
        }
    }
    if (types.length > 0) {
        if (isUniqueSelection) {
            pathname = `/category/type/${types[0]}`;
        } else {
            params.append('typ', types.join(','));
        }
    }
    if (languages.length > 0) {
        if (isUniqueSelection) {
            pathname = `/category/language/${languages[0]}`;
        } else {
            params.append('lan', languages.join(','));
        }
    }

    params.append('sort', sort);

    let url = new URL(window.location.href);
    url.pathname = pathname || '/viewall/';
    url.search = params.toString();
    return url;
};


class FilterBar {
    //function that handles the linkbar and its behaviour by adding event listeners
    init() {
        const filter = document.getElementById('topic-filter');
        if (!filter) {
            // skip initialisation if not available
            return;
        }

        this.SetSelectedFromQuery();

        const topicElements = document.querySelectorAll("#topic-filter li.child");
        const typeElements = document.querySelectorAll("#type-filter li.child");
        const languageElements = document.querySelectorAll("#language-filter li.child");
        const recentSortButton = document.querySelector("#sort-recent");
        const viewSortButton = document.querySelector("#sort-views");
        const clearFiltersButton = document.querySelector("#sorting-bar-clear-filter");

        topicElements.forEach((element) => {
            element.addEventListener('click', (e) => {
                if (element.classList.contains("selected")) {
                    element.classList.remove("selected");
                } else {
                    element.classList.add("selected");
                }
                this.SetQueryFromSelected();
            });
        });

        typeElements.forEach((element) => {
            element.addEventListener("click", (e) => {
                if (element.classList.contains("selected")) {
                    element.classList.remove("selected");
                } else {
                    element.classList.add("selected");
                }
                this.SetQueryFromSelected();
            });
        });

        languageElements.forEach((element) => {
            element.addEventListener('click', (e) => {
                if (element.classList.contains("selected")) {
                    element.classList.remove("selected");
                } else {
                    element.classList.add("selected");
                }
                this.SetQueryFromSelected();
            });
        });

        viewSortButton.addEventListener('click', (e)=>{
            if (!viewSortButton.classList.contains("selected")){
                viewSortButton.classList.add("selected");
                recentSortButton.classList.remove("selected");
                this.SetQueryFromSelected();
            }
        });

        recentSortButton.addEventListener('click', (e)=>{
            if (!recentSortButton.classList.contains("selected")){
                recentSortButton.classList.add("selected");
                viewSortButton.classList.remove("selected");
                this.SetQueryFromSelected();
            }
        });

        clearFiltersButton.addEventListener('click', (e)=>{
            const filters = document.querySelectorAll("#filters li");
            filters.forEach((e)=>{
                e.classList.remove("selected");
            });
            //to go to index page
            this.SetQueryFromSelected();
        });

        if (localStorage.sortingBar === 'expanded') {
            jQuery('.sorting-bar #filters').show();
            jQuery('.sorting-bar #filter-toggle span.more').hide();
            jQuery('.sorting-bar #filter-toggle span.less').show();
        }
    }

    //function that set the URL quury from the selected elements from the linkBar
    SetQueryFromSelected() {
        const topicElements = document.querySelectorAll("#topic-filter li.child.selected");
        const typeElements = document.querySelectorAll("#type-filter li.child.selected");
        const languageElements = document.querySelectorAll("#language-filter li.child.selected");
        const recentSortButton = document.querySelector("#sort-recent");
        const viewSortButton = document.querySelector("#sort-views");

        let selectedTopics = [];
        let selectedTypes = [];
        let selectedLanguages = [];

        topicElements.forEach((element) => {
            selectedTopics.push(element.dataset.category);
        });
        typeElements.forEach((element) => {
            selectedTypes.push(element.dataset.category);
        });
        languageElements.forEach((element) => {
            selectedLanguages.push(element.dataset.category);
        });

        let sort;

        if (recentSortButton.classList.contains("selected")) {
            sort = 'date';
        } else if (viewSortButton.classList.contains("selected")) {
            sort = 'views';
        }

        window.location.href = generateUrlForFilters(this.term, {
            topics: selectedTopics,
            types: selectedTypes,
            languages: selectedLanguages,
            categories: this.categories,
            tags: this.tags
        }, sort);
    }

    //function that sets the selected elements in the linkBar from the query
    //usefull when reloading page or accessing pre-sorted pages
    SetSelectedFromQuery() {
        let {
            term,
            filters: {
                topics: selectedTopics,
                types: selectedTypes,
                languages: selectedLanguages,
                tags,
                categories
            },
            sort: selectedSorting
        } = getFiltersFromUrl();

        this.term = term;
        this.tags = tags;
        this.categories = categories;

        const topicElements = document.querySelectorAll("#topic-filter li.child");
        const typeElements = document.querySelectorAll("#type-filter li.child");
        const languageElements = document.querySelectorAll("#language-filter li.child");
        const recentSortButton = document.querySelector("#sort-recent");
        const viewSortButton = document.querySelector("#sort-views");

        topicElements.forEach((element) => {
            if (selectedTopics.includes(element.dataset.category)) {
                element.classList.add("selected");
            }
        });

        typeElements.forEach((element) => {
            if (selectedTypes.includes(element.dataset.category)) {
                element.classList.add("selected");
            }
        });

        languageElements.forEach((element) => {
            if (selectedLanguages.includes(element.dataset.category)) {
                element.classList.add("selected");
            }
        });

        if (selectedSorting === "views"){
            viewSortButton.classList.add("selected");
            recentSortButton.classList.remove("selected");
        } else if (selectedSorting === "date"){
            recentSortButton.classList.add("selected");
            viewSortButton.classList.remove("selected");
        }
    }
}

let filterBar = new FilterBar();
filterBar.init();
